import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  inject,
  input,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { LanguageService, Language } from '../../services/language.service';

@Component({
  selector: 'app-language-selector',
  imports: [CommonModule, TranslateModule],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSelectorComponent {
  protected readonly languageService = inject(LanguageService);
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly destroyRef = inject(DestroyRef);

  readonly showTitle = input(true);
  readonly compact = input(false);
  readonly bare = input(false);

  protected readonly isOpen = signal(false);
  protected readonly languages: Language[] = this.languageService.languages;
  protected readonly currentLang = signal<Language>(
    this.languageService.getCurrentLanguageObj(),
  );

  constructor() {
    this.languageService.currentLanguage$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((code) => {
        const lang = this.languages.find((l) => l.code === code);
        this.currentLang.set(lang ?? this.languages[0]);
      });
  }

  protected toggleDropdown(): void {
    this.isOpen.update((v) => !v);
  }

  protected selectLanguage(lang: Language): void {
    this.languageService.setLanguage(lang.code);
    this.isOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  protected onClickOutside(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.isOpen.set(false);
    }
  }
}
